import { Component, HostListener, OnInit } from '@angular/core';
import {LoginService} from '../../login-service';
import { FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Route, Router, RouterModule } from '@angular/router';
import { ImageuploadService } from '../../Imageupload.service';
import { DropDownList } from '../../sociallogins';
import {PostcollaboComponent} from '../postcollabo/postcollabo.component';
@Component({
  selector: 'app-profile-setup',
  templateUrl: './profile-setup.component.html',
  styleUrls: ['./profile-setup.component.scss'],
  providers:[PostcollaboComponent]
})


export class ProfileSetupComponent implements OnInit {

  dragAreaClass: string;
  canshowFirstTab = true;
  canshowSecondTab = false;
  canshowThirdTab = false;
  canshowFourthTab = false;
  region:any;
  skills:any;
  additionalSkills:any
  addskillsList:any=[];
  checked:boolean=false;
  displaysubmit:boolean=false;
  legalName:any;
  documentType:any;
  collaboPath:any;
  country:any;
  addportfolio:boolean=true;
  displayfilename:boolean=false;
  displayfilename1:boolean=false;
  displayfilename2:boolean=false;
  district:any;
  city:any;
  industry:any;
  experience:any;
  capitalInvestment:any;
  reference:any;
  workIndustry:any;
  workExperience:any;
  workDescription:any;
  collegeName:any;
  educationStartDate:any;
  educationEndDate:any;
  certificateCopy:any;
  certificateTitle:any;
  certificateDesc:any;
  portfolio:any;
  portfolioTitle:any;
  portfolioDesc:any;
  currentTabNumber=1;
  skillsList:any;
  errorMessage:string;
  registerForm: FormGroup;
  registerForm1: FormGroup;
  registerForm2work: FormGroup;
  registerForm2col: FormGroup;
  registerForm2cert: FormGroup;
  selectedCountry=0;
  registerForm3: FormGroup;
  submitted=false;
  tabtype:string;
  selectedSkillsListid:any=[];
  selectedSkillsList:any=[];
  selectedSkillsListname:any=[];
  selectedItem:any;
  addWorkList:any=[];
  addEducationList:any=[];
  addCertificatesList:any=[];
  addportfolioList:any=[];
  addnewwork:boolean=false;
  count=0;
  userID:any;
  tabValue:any;
  usertype: string;
  change: string;
  documetpath: any;
  imagefile: any;
  documentpath: any;
countriesList: any;
portfoliopath: any;
  certificationpath: any;
  filename: string;
  typeoffile: string;
  statesList: any;
  filteredstatesList: any;
  citiesList: any;
  filteredcitiesList: any;
  state: any;
  country1: any;
 addedform:boolean=false;
addcertform:boolean=false;
currency:any;
CurrencyList:any;
  experience1: any;
  reference1: any;
  certificatepath: string;
  legaldocpathname: string;
  portfoliopathname: string;
  constructor(private router: Router,private formBuilder: FormBuilder,public imageservice: ImageuploadService,private loginService:LoginService,private activateRoute:ActivatedRoute) { 
    this.userID = this.activateRoute.snapshot.params['userID'];
    this.tabValue=this.activateRoute.snapshot.params['tabvalue'];
  }

  ngOnInit(): void {
    this.typeoffile="legaldoc"
    this.selectedCountry=7;
    this.dragAreaClass = "dragarea";
    this.documetpath=this.documentpath;
    this.getSkills();
    this.getCountries();
    this.getCurrencies();
    this.tabtype="step1";
    console.log(this.tabtype)
    this.change=localStorage.getItem('PROCESS')
    this.usertype=localStorage.getItem('SIGNEDUPAS')
    this.registerForm = this.formBuilder.group({
      region: ['', [Validators.required]],  
      skills:['',[Validators.required]],    
  }
  );
  if(this.tabValue==1)
{
  this.displaysubmit=true;
  this.registerForm1 = this.formBuilder.group({
    legalName: ['',[ Validators.required]],
    documentType: ['',[ Validators.required]],
    country: ['',[ Validators.required]],
    district: ['', [Validators.required]],
     city: ['', [Validators.required]],
    industry: ['',[ Validators.required]],
    capitalInvestment: ['', [Validators.required]],
    currency:['', [Validators.required]],
});
}
else if(this.tabValue==2)
{
  this.displaysubmit=false;
  this.registerForm1 = this.formBuilder.group({
    legalName: ['',[ Validators.required]],
    documentType: ['',[ Validators.required]],
    country: ['',[ Validators.required]],
    district: ['', [Validators.required]],
     city: ['', [Validators.required]],
    industry: ['',[ Validators.required]],
    experience: ['', [Validators.required]],
    reference: ['', [Validators.required]],
    capitalInvestment: ['', [Validators.required]],
    currency:['', [Validators.required]],
    
});
}
  
// experience: ['', [Validators.required]],
// reference: ['', [Validators.required]],
// country: ['', Validators.required],
// district: ['', Validators.required],
//  city: ['', Validators.required],
this.registerForm2work = this.formBuilder.group({  
  workIndustry: ['', [Validators.required]],
  workExperience: ['', [Validators.required]],
  workDescription: ['', [Validators.required]],
}
);
this.registerForm2col = this.formBuilder.group({
  collegeName: ['', [Validators.required]],
  educationStartDate: ['', [Validators.required]],
  educationEndDate: ['', [Validators.required]],
}
);
this.registerForm2cert = this.formBuilder.group({
  //certificateCopy: ['', Validators.required],
  certificateTitle: ['', [Validators.required]],
  certificateDesc: ['', [Validators.required]], 
}
);
this.registerForm3 = this.formBuilder.group({
  
 // portfolio: ['', Validators.required],
  portfolioTitle: ['', [Validators.required]],
  portfolioDesc: ['', [Validators.required]],
}
);


  }
  get f() { return this.registerForm.controls;}
get g(){return this.registerForm1.controls;}
get j(){ return this.registerForm2work.controls; }
get j1(){ return this.registerForm2col.controls; }
get j2(){ return this.registerForm2cert.controls; }
get k(){return this.registerForm3.controls;}
//drag
@HostListener("dragover", ["$event"]) onDragOver(event: any) {
  this.dragAreaClass = "droparea";
  event.preventDefault();
}
@HostListener("dragenter", ["$event"]) onDragEnter(event: any) {
  this.dragAreaClass = "droparea";
  event.preventDefault();
}
@HostListener("dragend", ["$event"]) onDragEnd(event: any) {
  this.dragAreaClass = "dragarea";
  event.preventDefault();
}
@HostListener("dragleave", ["$event"]) onDragLeave(event: any) {
  this.dragAreaClass = "dragarea";
  event.preventDefault();
}
@HostListener("drop", ["$event"]) onDrop(event: any) {
  this.dragAreaClass = "dragarea";
  event.preventDefault();
  event.stopPropagation();
  if (event.dataTransfer.files) {
    this.displayfilename=true;
    this.displayfilename1=true;
    this.displayfilename2=true;
    let files: FileList = event.dataTransfer.files;
    console.log(files[0])
    console.log(files.length);
    console.log(files[0].type);
    this.filename=files[0].name
    console.log(files[0].type=="application/pdf");
    console.log(this.documetpath)
    this.documentpath=this.registerForm1.value.documetpath;
    console.log(this.documentpath)
    console.log(this.userID)
     if(files[0].type=="application/pdf"||"application/doc")
     {
    this.imagefile = this.loginService.filechange2(files[0],files.length,this.userID,this.typeoffile);
    console.log(this.imagefile);
    // if(param=="Collabo")
    // {
    //   console.log("collabo param")
    this.imageservice.ImageUplode1.subscribe(Img => this.documentpath = Img
      );
      console.log(this.documentpath);
     }
     else if(files[0].type=="image/png"||"image/jpg"||"image/jpeg")
     {
      this.imagefile = this.loginService.filechange2(files[0],files.length,this.userID,this.typeoffile);
      console.log(this.imagefile);
      // if(param=="Collabo")
      // {
      //   console.log("collabo param")
      this.imageservice.ImageUplode.subscribe((Img) => {this.documentpath = Img;
        console.log(Img)});
      console.log(this.documentpath);
      
     }
  }
}
closefile()
{
  this.displayfilename=false;
  this.displayfilename1=false;
  this.displayfilename2=false;
}
  getSkills(){
    
    this.loginService.Getskills(2).subscribe(data=>
      {
        data = JSON.parse(data['_body']);
        this.skillsList = data;
        console.log("skills:"+this.skillsList);
      });
   
 } 
//  getCountries(){
    
//   this.loginService.GetCountries().subscribe(data=>
//     {
//       data = JSON.parse(data['_body']);
//       this.countriesList = JSON.parse(JSON.stringify(data));
//       console.log("countriesList:"+this.countriesList);
//     });
 
// } 
 displaynewwork(){
   this.addnewwork=true;
   console.log(this.addnewwork);
   this.displayfilename1=false;
   this.typeoffile="certification";
 }
 cancelwork(){
  this.addnewwork=false;
 }
 editwork(data){
   console.log(data);
   this.addnewwork=true;
   this.workIndustry=data.Industry;
   this.workExperience=data.Experience;
   this.workDescription=data.Description;
 }
displayedform(){
  this.addedform=true;
  console.log(this.addedform)
}
canceledform(){
  this.addedform=false;
}
displaycertform(){
  this.addcertform=true;
}
cancelcertform(){
  this.addcertform=false;
}
  gotoStep2(){
    this.typeoffile="legaldoc";
    console.log("submit step 1")
    //this.currentTabNumber++;
    this.submitted = true;
 this.region=this.registerForm.value.region;

    // stop here if form is invalid
   
   
      
       if (this.registerForm.valid) {
        const jsonData = {
          RegionName:this.region,
          Skillid:this.selectedSkillsListid,
          AdditionalSkills:this.addskillsList,
          userid:this.userID,
      CreatedBy:'NewUser',
      UpdatedBy:'NewUser',
      RowID:"",
     
        };
       console.log(jsonData);
       this.loginService.SaveRegionSkills(jsonData).subscribe((dataJson) => {
        console.log(dataJson);
        console.log(dataJson['_body'].toString());     
        if (dataJson['_body'].toString() === 'true') {
        //  alert("saved successfully");
         this.loginService.showSuccess("Skills Save Successfully..!", "");
         
        }
        else{
          this.loginService.showError("Skills Save Failed..!", "");
         
        }
      });
     
      this.tabtype="step2";
       console.log(this.tabtype)
     
    
    
    
  }
  }
 
  fileChange(input,param) {
    this.displayfilename=true;
    this.displayfilename1=true;
    this.displayfilename2=true;
    console.log(this.documetpath)
    this.filename=input.files[0].name
    this.documentpath=this.registerForm1.value.documetpath;
    console.log(param);
    console.log("in filechange of certification");
    console.log(this.typeoffile);
    console.log(input);
    this.imagefile = this.loginService.filechange1(input,param,this.userID);
    if(param=="certification")
    {
      var path="Images/certification/"+this.userID+"/"+this.filename;
      localStorage.setItem("certificatepath",path);
    }
    else if(param=="legaldoc")
    {
      var path="Images/legaldoc/"+this.userID+"/"+this.filename;
      localStorage.setItem("legaldocpath",path);
    }
    else if(param=="portfolio"){
      var path="Images/portfolio/"+this.userID+"/"+this.filename;
      localStorage.setItem("portfoliopath",path);
    }
    console.log(this.imagefile);
    // if(param=="Collabo")
    // {
    //   console.log("collabo param")
    this.imageservice.ImageUplode1.subscribe(Img => this.documentpath = Img
    );
    console.log(this.documentpath);
    // }
    // else if(param.toString()=="Legaldocuments"){
    //   console.log("legaldocuments param")
    // this.imageservice.ImageUplode.subscribe(Img => this.uploadLegalDocuments = Img);
    // }
    // console.log(this.uploadLegalDocuments)


  }
  getCurrencies(){
    
    this.loginService.GetCurrencies().subscribe(data=>
      {
        data = JSON.parse(data['_body']);
        this.CurrencyList = JSON.parse(JSON.stringify(data));
        console.log(this.CurrencyList);
      });
   
  }
  getCountries(){
    
    this.loginService.GetCountries().subscribe(data=>
      {
        data = JSON.parse(data['_body']);
        this.countriesList = JSON.parse(JSON.stringify(data));
        console.log("countriesList:"+this.countriesList);
      });
   
  }
  
    getStates(event){
      
      console.log(this.country);
      this.country1=this.country;
      let id=event.target.value;
      let name=event.target.name;
      this.country=name;
      console.log(id,name)
      this.loginService.GetStates().subscribe(data=>
        {
          data = JSON.parse(data['_body']);
          this.statesList = data;
          console.log(this.statesList);
          let countryname=this.countriesList.filter(x=>x.id==id);
          console.log(countryname);
          this.country=countryname[0].name;
          console.log(this.country);
          this.filteredstatesList=this.statesList.filter(x=>x.country_id==id);
          console.log(this.filteredstatesList);
        })
      }
      getCities(event){
        console.log(this.state,this.district)
      // let id=event.target.value;
      // let name=event.target.name;
      // let statename=this.statesList.filter(x=>x.id==id);
      //     console.log(statename);
      //     this.district=statename[0].name;
      //     console.log(this.district);
          // this.state=this.district;
    // this.loginService.GetCities().subscribe(data=>
    //   {
    //     data = JSON.parse(data['_body']);
    //     this.citiesList = data;
    //     console.log(this.citiesList);
    //     let statename=this.statesList.filter(x=>x.id==id);
    //       console.log(statename);
    //       this.district=statename[0].name;
    //       console.log(this.district);
    //     this.filteredcitiesList=this.citiesList.filter(x=>x.state_id==id);
    //     console.log(this.filteredcitiesList);
    //   })
    }
  // citiesName(event){
  //   let id=event.target.value;
  //   let name=event.target.name;
  //   let cityname=this.citiesList.filter(x=>x.id==id);
  //         console.log(cityname);
  //         // this.city=cityname[0].name;
  //         console.log(this.city);
  // }
 
  gotoStep3(){
    this.displayfilename1=false;
    console.log(this.documentpath);
    this.legaldocpathname=localStorage.getItem("legaldocpath")
    console.log(this.experience1,this.reference1)
    console.log(this.documentType,this.legalName,this.country,this.city,this.district,this.industry,this.experience,this.capitalInvestment,this.reference,this.currency)
    console.log(this.registerForm1.valid);
    if(this.registerForm1.valid){
      const json={
        Documentpath:this.legaldocpathname,
        TypeOfProof:this.documentType,
        LegalName:this.legalName,
        Country:this.country,
        City:this.city,
        DistrictTown:this.state,
        Industry:this.industry,
        Experience:this.experience,
        CapitalInvestment:this.capitalInvestment,
        Reference:this.reference,
        DocumentName:this.filename,
        userid:this.userID,
         CreatedBy:'Admin',
         currency:this.currency
        };
        console.log(json); 
      
      
        this.loginService.SaveLegalDocuments(json).subscribe((dataJson) => {
          console.log("in saving process")
         console.log(dataJson);
         console.log(dataJson['_body'].toString());
         if (dataJson['_body'].toString() === 'true') {
          
          //  alert("Saved Successfully");
          this.loginService.showSuccess("Legal Documents Save Successfully..!", "");
          localStorage.removeItem("legaldocpath")
            setTimeout(() => {
              //this.message = "";
            }, 5000);
           
            
       }
       else{
        this.loginService.showError("Legal Documents Save Failed..!", "");
         
       }
      
         });
         if(this.tabValue==2)
    {
      this.tabtype="step3";
      console.log(this.tabtype);
    }
    if(this.tabValue==1)
    {
      this.loginService.updateprofilestatus(this.userID,"y").subscribe(data=>{console.log(data)})
      let collabostatus=localStorage.getItem('CollaboPosted')
      console.log(collabostatus);
      if(collabostatus!=null&&collabostatus.toString()=='true'){
        let json=localStorage.getItem('collabojson')
        var json1=JSON.parse((json))
        console.log(json1)
        
        json1.userID=this.userID;
        console.log(json1)
        this.loginService.SaveCollabos(json1).subscribe(data=>
          {
              console.log(data); 
              console.log(data['_body'].toString()!= '0');
              localStorage.removeItem('collabojson')
              localStorage.removeItem('CollaboPosted')
              this.router.navigate(['/initatorcollabo',this.userID,'profile-setup']);
              
          })
        // this.postcollabo.SaveCollabo(this.userID);
      }
      else{
       
              this.router.navigate(['/initatorcollabo',this.userID,'profile-setup']);
      }
      this.router.navigate(['/initatorcollabo',this.userID,'profile-setup']);
    }
  }
  }
  skip()
  {
    var loggedinas=localStorage.getItem("LOGGEDINAS")
    if(this.tabValue==1)
    {

      console.log(this.usertype);
      this.router.navigate(['/initatorcollabo',this.userID,'profile-setup']);
      this.loginService.showSuccess("Logged in as a initiator..!", "");
    }
    else if(this.tabValue==2)
    {
      console.log(this.usertype);
      this.router.navigateByUrl('collabo');
      this.loginService.showError("Logged in as a collabarator..!", "");
    }
  }
  gotoStep4(){
    this.typeoffile="portfolio";
    this.displayfilename2=false;
    // if(this.addWorkList===""|| this.addWorkList.length===0 || this.addEducationList===""|| this.addEducationList.length===0
    // || this.addportfolioList==="" || this.addportfolioList.length===0){
    //   alert("Please add your Work,Education and Certificate History");
    //   return;
    // }
    // else{
      if(this.tabValue==2)
    {
      this.tabtype="step4";
      console.log(this.tabtype);
   // }
    }
  }
  //file upload for legaldocument
  view(doc,param)
{
  console.log(doc,param);
  if(param=="certification")
  {
  this.certificatepath=localStorage.getItem("certificatepath");
  window.open(this.loginService.imageURL+ this.certificatepath);
  }
  else if(param=="portfolio")
  {
  this.portfoliopathname=localStorage.getItem("portfoliopath");
  window.open(this.loginService.imageURL+this.portfoliopathname);
  }
  else
  {
  this.legaldocpathname=localStorage.getItem("legaldocpath");
  window.open(this.loginService.imageURL+this.legaldocpathname);
  }
 
}
  Save(){
    //if(this.registerForm3.valid){
      

      // alert("Data saved successfully");
      if(this.tabValue==1)
    {

      console.log(this.usertype);
      this.router.navigate(['/initatorcollabo',this.userID,'profile-setup']);
      this.loginService.showSuccess("Logged in as a initiator..!", "");
    }
    else if(this.tabValue==2)
    {
      console.log(this.usertype);
      this.loginService.updateprofilestatus(this.userID,"y").subscribe(data=>{console.log(data)
        let bidstatus=localStorage.getItem('BidSubmitted')
        console.log(bidstatus);
        if(bidstatus!=null&&bidstatus.toString()=='true'){
          let json=localStorage.getItem('Bidjson')
          var json1=JSON.parse((json))
          console.log(json1)
          
          json1.userid=this.userID;
          console.log(json1)
          this.loginService.SavePraposalBids(json1).subscribe(data=>
            {
                console.log(data); 
                console.log(data['_body'].toString()!= '0');
                localStorage.removeItem('Bidjson')
                localStorage.removeItem('BidSubmitted')
                this.router.navigateByUrl('collabo');
                this.loginService.showSuccess("Logged in as a collabarator..!", "");
            })
          // this.postcollabo.SaveCollabo(this.userID);
        }
      })
      // this.router.navigate(['/subscribe',this.userID]);
      this.router.navigateByUrl('collabo');
      this.loginService.showSuccess("Logged in as a collabarator..!", "");
    }
   // }
  }
  gobacktoStep1(){
    this.tabtype="step1";
  }
  gobacktoStep2(){
    this.tabtype="step2";
  }
  gobacktoStep3(){
    this.tabtype="step3";
  }

  addAdditionalskills(){
    console.log(this.additionalSkills);
    this.addskillsList.push(this.additionalSkills);
    console.log(this.addskillsList)
  }
 onKey(e){
   this.additionalSkills=e.target.value;
   console.log(this.additionalSkills)
 }
 
   checkedOn(e,data){
    // console.log(data)
     if(e.target.checked){
     this.checked=true;
     const jdata={
      id:e.target.id,
      value:e.target.value,
      check:this.checked
    }
     console.log(e.target.value);
     //this.selectedItem=e;
     this.selectedSkillsListid.push(e.target.id)
     this.selectedSkillsListname.push(e.target.value)
     this.selectedSkillsList.push(jdata.check);
     console.log(this.selectedSkillsList);
     console.log(this.selectedSkillsList.check)
     
     }
     else {
      var index = this.selectedSkillsListid.indexOf(e.target.id);
      console.log(index)
     this.checked=false;
     this.selectedSkillsListid.splice(index,1)
    //  this.selectedSkillsListid.slice(e.target.id,this.checked)
     this.selectedSkillsListname.splice(index,1)
     }
     
   console.log(this.selectedSkillsListid)
   console.log(this.selectedSkillsListname)
     
  }
 
  addWork(){
    if(this.registerForm2work.valid){
    console.log(this.workIndustry);
    console.log(this.workExperience);
    console.log(this.workDescription);
    
    const json={
      industry:this.workIndustry,
      experience:this.workExperience,
      description:this.workDescription
    }
    this.addWorkList.push(json);
    
    console.log(this.addWorkList);

    const jsonData = {
      Industry:this.workIndustry,
      Experience:this.workExperience,
      Description:this.workDescription,
      userid:this.userID,
  CreatedBy:'NewUser',
  UpdatedBy:'NewUser',
  RowID:"",
 
    };
   console.log(jsonData);
   this.loginService.SaveWorkExperience(jsonData).subscribe((dataJson) => {
    console.log(dataJson);
    console.log(dataJson['_body'].toString());     
    if (dataJson['_body'].toString() === 'true') {
     //alert("saved successfully");
     this.loginService.showSuccess("Work Experience Save Successfully..!", "");
       
     
    }
    else{
      this.loginService.showError("Work Experience Save Failed..!", "");
       
    }
  });
  this.workIndustry="";
    this.workExperience="";
    this.workDescription="";
  this.addnewwork=false;
}
  }
  addEducation(){
    if(this.registerForm2col.valid){
    console.log(this.collegeName);
    console.log(this.educationStartDate);
   
    const json={
      collegename:this.collegeName,
      educationstartdate:this.educationStartDate,
      educationenddate:this.educationEndDate     
    }
    this.addEducationList.push(json);
   
    console.log(this.addEducationList);

    const jsonData = {
      CollegeName:this.collegeName,
      Startdate:this.educationStartDate,
      Enddate:this.educationEndDate,
      userid:this.userID,
  CreatedBy:'NewUser',
  UpdatedBy:"NewUser",
  RowId:"",
 
    };
   console.log(jsonData);
   this.loginService.SaveEducation(jsonData).subscribe((dataJson) => {
    console.log(dataJson);
    console.log(dataJson['_body'].toString());     
    if (dataJson['_body'].toString() === 'true') {
    //  alert("saved successfully");
    this.loginService.showSuccess("Education Save Successfully..!", "");
       
     
    }
    else{ this.loginService.showError("Education Save Failed..!", "");
       

    }
  });
  this.collegeName="";
  this.educationStartDate="";
  this.educationEndDate="";
  this.addedform=false;
}
  }
  addCertificates(){
    if(this.registerForm2cert.valid){
    console.log(this.certificateTitle);
    console.log(this.certificateDesc);
    
    const json={
      certiTitle:this.certificateTitle,
      certiDesc:this.certificateDesc     
    }
    this.addCertificatesList.push(json);
    
    console.log(this.addCertificatesList);
     this.certificatepath=localStorage.getItem("certificatepath");
    const jsonData = {
      Certificationpath:this.certificatepath,
      certificationName:this.filename,
      Title:this.certificateTitle,
      Description:this.certificateDesc,
      userid:this.userID,
  CreatedBy:'NewUser',
  UpdatedBy:'NewUser',
  RowID:"",
 
    };
   console.log(jsonData);
   this.loginService.SaveCertification(jsonData).subscribe((dataJson) => {
    console.log(dataJson);
    console.log(dataJson['_body'].toString());     
    if (dataJson['_body'].toString() === 'true') {
    //  alert("saved successfully");
    this.loginService.showSuccess("Certification Save Successfully..!", "");
    localStorage.removeItem("certificatepath");
    }
    else{
      this.loginService.showError("Certification Save Failed..!", "");
       
    }
  });
  this.certificateTitle="";
  this.certificateDesc="";
  
  this.addcertform=false;
}
  }
  addPorfolios(){
   
  
    console.log(this.portfolioTitle);
    console.log(this.portfolioDesc);
    if(this.registerForm3.invalid ){
      return;
    }
   else{
    const json={
      portfoliotitle:this.portfolioTitle,
      portfoliodesc:this.portfolioDesc,     
    }
    this.addportfolioList.push(json);
    this.portfoliopathname=localStorage.getItem("portfoliopath")
    console.log(this.addportfolioList);

    const jsonData = {
      Portfoliopath:this.portfoliopathname,
      Title:this.portfolioTitle,
      Description:this.portfolioDesc,
      portfolioName:this.filename,
      userid:this.userID,
  CreatedBy:'NewUser',
  UpdatedBy:'NewUser',
  RowID:"",
 
    };
   console.log(jsonData);
   this.loginService.SavePortfolio(jsonData).subscribe((dataJson) => {
    console.log(dataJson);
    console.log(dataJson['_body'].toString());     
    if (dataJson['_body'].toString() === 'true') {
    //  alert("saved successfully");
    this.loginService.showSuccess("Portfolio Save Successfully..!", "");
    localStorage.removeItem("portfoliopath") 
    }
    else{
      this.loginService.showError("Portfolio Save Failed..!", "");
         
    }
  });
  this.portfolioTitle="";
    this.portfolioDesc="";

  }

  }

}
